export const API_BASE_PATH = '/api/v1';
export const INTERNAL_BASE_PATH = '/api/v1/internal/admin';
export const ADMIN_BASE_PATH = `${API_BASE_PATH}/admin`;
export const LAS_BASE_PATH = `${ADMIN_BASE_PATH}/las`;
